import { isNumber, isString } from 'lodash';
import moment from 'moment';

export const abbreAddress = (d: string) => {
  if (d?.length > 0) {
    let first = d.slice(0, 3);
    let last = d.slice(d.length - 2, d.length);

    return `${first}...${last}`;
  }
  return '';
};

export const abbreAddresFourNmbers = (d: string) => {
  if (d?.length > 0) {
    let first = d.slice(0, 4);
    let last = d.slice(d.length - 4, d.length);

    return `${first}...${last}`;
  }
  return '';
};

export const comma3digits = (d: any) => {
  let result: string = '';
  let _d: number | string = Math.round(Number(d) * 100) / 100;
  if (isNumber(_d)) {
    result = _d.toString()
  }
  result = result.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  return result;
};

export const shortString = (d: string, num1: number, num2: number) => {
  if (d && d?.length > 0) {
    let first = d.slice(0, num1);
    let last = d.slice(d.length - num2, d.length);

    return `${first}...${last}`;
  }
  return '';
};

export const formatDate = (date: any) => {
  return moment(date).format('MMM YYYY');
};

export const formatFullDate = (date: any) => {
  return moment(date).format('DD/MM/YYYY');
};

export const formatFullDateV2 = (date: any) => {
  return moment(date).format('MMM DD, YYYY');
};

export const formatSmallDate = (date: any) => {
  return moment(date).format('DD/MM');
};


export const roundDecimal = (decimal: any, digit: any) => {
  return Math.round(decimal * 10 ** digit) / 10 ** digit;
};

export const tierLevel = (tier: number) => {
  switch (tier) {
    case 1:
      return "Whales";
    case 2:
      return "Sharks";
    case 3:
      return "Dolphins";
    case 4:
      return "Fishes";
    case 5:
      return "Planktons";
    default:
      return "No level"
  }
}

export const nextTierRequirement = (tier: number) => {

  switch (tier) {
    case 2:
      return 200000;
    case 3:
      return 100000;
    case 4:
      return 30000;
    case 5:
      return 10000;
    default:
      return 1000;
  }
}